<template>
    <client-page class="app--main">

        <div class="visual d-flex align-center">
            <v-container>
                <v-row>
                    <v-col cols="12" lg="6" class="d-flex flex-column align-center justify-center mb-20 mb-lg-0">
                        <div class="visual-ani-group text-center text-lg-left">
                            <div class="visual-ani">
                                <h2>A new standard</h2>
                            </div>
                            <div class="visual-ani mb-18 mb-md-30 mb-lg-44">
                                <h2>for web security</h2>
                            </div>
                            <div class="visual-ani">
                                <p>UWSS is an All-in-One SECaaS platform</p>
                            </div>
                            <div class="visual-ani">
                                <p>that realizes global cloud security services.</p>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <img src="/images/main/visual.png" alt="" class="d-block ma-auto visual-il">
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <section class="main-section main-section1">
            <v-container>

                <div class="d-flex justify-space-between align-end mb-40 mb-lg-80">
                    <h3 class="main-title mb-0 mb-lg-0">
                        All-in-One SECaaS <br>
                        platform UWSS 
                    </h3>
                    <v-btn text class="arrow-btn" href="/en/products/UWSS">Learn more <img src="/images/icon/right-arrow.png" alt=""> </v-btn>
                </div>

                <v-row class="align-center mb-50 mb-lg-100">
                    <v-col cols="12" lg="6">
                        <img src="/images/main/s1-img1.png" alt="" class="d-block w-100">
                    </v-col>
                    <v-col cols="12" lg="5" offset-lg="1">
                        <h4 class="txt-40 mb-8 mb-lg-28">
                            Providing a manager for integrated management
                        </h4>
                        <p class="dot-txt txt-22 color-gray mb-4 mb-lg-8">
                            Provided by service
                        </p>
                        <p class="dot-txt txt-22 color-gray mb-4 mb-lg-8">
                            Support for various cloud platforms
                        </p>
                        <p class="dot-txt txt-22 color-gray">
                            Pay only for what you use
                        </p>
                    </v-col>
                </v-row>

                <v-row class="align-lg-center flex-column-reverse flex-lg-row mb-50 mb-lg-100">
                    <v-col cols="12" lg="5" offset-lg="1">
                        <h4 class="txt-40 mb-8 mb-lg-28">
                            Optimized for the cloud
                        </h4>
                        <p class="dot-txt txt-22 color-gray mb-4 mb-lg-8">
                            Azure, AWS, KT cloud marketplace
                        </p>
                        <p class="dot-txt txt-22 color-gray mb-4 mb-lg-8">
                            Providing Auto scaling
                        </p>
                        <p class="dot-txt txt-22 color-gray">
                            Applicable without structural change
                        </p>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <img src="/images/main/s1-img2.png" alt="" class="d-block w-100">
                    </v-col>
                </v-row>

                <v-row class="align-center mb-50 mb-lg-100">
                    <v-col cols="12" lg="6">
                        <img src="/images/main/s1-img3.png" alt="" class="d-block w-100">
                    </v-col>
                    <v-col cols="12" lg="5" offset-lg="1">
                        <h4 class="txt-40 mb-8 mb-lg-28">
                            Web Application security
                        </h4>
                        <p class="dot-txt txt-22 color-gray mb-4 mb-lg-8">
                            Web application firewall
                        </p>
                        <p class="dot-txt txt-22 color-gray mb-4 mb-lg-8">
                            Anti Web shell
                        </p>
                        <p class="dot-txt txt-22 color-gray">
                            Web malware distribution scanning
                        </p>
                    </v-col>
                </v-row>

                <v-row class="align-lg-center flex-column-reverse flex-lg-row">
                    <v-col cols="12" lg="5" offset-lg="1">
                        <h4 class="txt-40 mb-8 mb-lg-28">
                            Monitoring & Report
                        </h4>
                        <p class="dot-txt txt-22 color-gray mb-4 mb-lg-8">
                            Providing dashboard for each service
                        </p>
                        <p class="dot-txt txt-22 color-gray mb-4 mb-lg-8">
                            Providing integrated dashboard and reports
                        </p>
                        <p class="dot-txt txt-22 color-gray">
                            Notification services
                        </p>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <img src="/images/main/s1-img4.png" alt="" class="d-block w-100">
                    </v-col>
                </v-row>

            </v-container>
        </section>

        <section class="main-section main-section2">
            <v-container>

                <h3 class="main-title">
                    Solution
                </h3>

                <v-row>
                    <v-col cols="12" lg="7">
                        <div class="s2-left-item radius shadow pa-16 px-md-60 py-md-80">
                            <img src="/images/logo-w.svg" alt="" class="d-block mb-36 mb-lg-60" width="240">
                            <img src="/images/main/s2-icon1.png" alt="" class="d-block mb-12 mb-lg-24">
                            <h5 class="txt-28 font-weight-400 color-white mb-60 mb-lg-166">
                                We provide web hacking prevention, detection, and response as one unified web security service.
                            </h5>
                            <div class="d-flex justify-end">
                                <v-btn icon outlined large class="arrow-icon-btn" color="white" href="/en/products/UWSS">
                                    <span class="arrow-btn-icon-wrap">
                                        <div class="arrow-btn-icon">
                                            <img src="/images/icon/right-arrow-w.png" alt="" class="d-block arrow-icon-show">
                                            <img src="/images/icon/right-arrow-w.png" alt="" class="d-block arrow-icon-hover">
                                        </div>
                                    </span>
                                </v-btn>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="5">
                        <div class="h-100 d-flex flex-column justify-space-between">
                            <div class="s2-right-item radius shadow pa-16 pa-md-40 mb-12 mb-lg-0">
                                <div class="d-flex justify-space-between mb-20 mb-lg-44">
                                    <img src="/images/castle-logo.svg" alt="" class="d-block s2-right-logo">
                                    <v-btn icon outlined large class="arrow-icon-btn" color="primary" href="/en/products/WEB">
                                    <span class="arrow-btn-icon-wrap">
                                        <div class="arrow-btn-icon">
                                            <img src="/images/icon/right-arrow.png" alt="" class="d-block arrow-icon-show">
                                            <img src="/images/icon/right-arrow-w.png" alt="" class="d-block arrow-icon-hover">
                                        </div>
                                    </span>
                                </v-btn>
                                </div>
                                <div class="d-flex align-center">
                                    <img src="/images/main/s2-icon2.png" alt="" class="d-block mr-6 mr-lg-12">
                                    <p class="txt-22">Defend and block web attacks</p>
                                </div>
                            </div>
                            <div class="s2-right-item radius shadow pa-16 pa-md-40 mb-20 mb-lg-0">
                                <div class="d-flex justify-space-between mb-12 mb-lg-44">
                                    <img src="/images/finder-logo.svg" alt="" class="d-block s2-right-logo">
                                    <v-btn icon outlined large class="arrow-icon-btn" color="primary" href="/en/products/WS">
                                    <span class="arrow-btn-icon-wrap">
                                        <div class="arrow-btn-icon">
                                            <img src="/images/icon/right-arrow.png" alt="" class="d-block arrow-icon-show">
                                            <img src="/images/icon/right-arrow-w.png" alt="" class="d-block arrow-icon-hover">
                                        </div>
                                    </span>
                                </v-btn>
                                </div>
                                <div class="d-flex align-center">
                                    <img src="/images/main/s2-icon3.png" alt="" class="d-block mr-6 mr-lg-12">
                                    <p class="txt-22">Malicious Webshell detection and deletion</p>
                                </div>
                            </div>
                            <div class="s2-right-item radius shadow pa-16 pa-md-40">
                                <div class="d-flex justify-space-between mb-20 mb-lg-44">
                                    <img src="/images/ds-logo.svg" alt="" class="d-block s2-right-logo">
                                    <v-btn icon outlined large class="arrow-icon-btn" color="primary" href="/en/products/WMDS">
                                    <span class="arrow-btn-icon-wrap">
                                        <div class="arrow-btn-icon">
                                            <img src="/images/icon/right-arrow.png" alt="" class="d-block arrow-icon-show">
                                            <img src="/images/icon/right-arrow-w.png" alt="" class="d-block arrow-icon-hover">
                                        </div>
                                    </span>
                                </v-btn>
                                </div>
                                <div class="d-flex align-center">
                                    <img src="/images/main/s2-icon4.png" alt="" class="d-block mr-6 mr-lg-12">
                                    <p class="txt-22">Prohibition of malicious code distribution</p>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>

            </v-container>
        </section>

        <section class="main-section main-section3">
            <v-container>

                <h3 class="main-title">
                    UWSS Key Features
                </h3>

                <h4 class="line-txt txt-40 font-weight-700 mb-30 mb-lg-52">
                    Web Application security
                </h4>

                <v-row>
                    <v-col cols="12" lg="4">
                        <div class="radius-sm shadow w-100 pa-16 pa-md-40 s3-item d-flex flex-column justify-space-between">
                            <div class="mb-20 mb-lg-0">
                                <span class="d-block font-size-14 font-size-lg-20 font-weight-700 line-height-1 color-point mb-8 mb-lg-18">
                                    01
                                </span>
                                <p class="txt-22 font-weight-700">Web application firewall</p>
                            </div>
                            <div class="d-flex justify-end">
                                <img src="/images/main/s3-icon1.png" alt="" class="d-block">
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="4">
                        <div class="radius-sm shadow w-100 pa-16 pa-md-40 s3-item d-flex flex-column justify-space-between">
                            <div class="mb-20 mb-lg-0">
                                <span class="d-block font-size-14 font-size-lg-20 font-weight-700 line-height-1 color-point mb-8 mb-lg-18">
                                    02
                                </span>
                                <p class="txt-22 font-weight-700">Anti Web shell</p>
                            </div>
                            <div class="d-flex justify-end">
                                <img src="/images/main/s3-icon2.png" alt="" class="d-block">
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="4">
                        <div class="radius-sm shadow w-100 pa-16 pa-md-40 s3-item d-flex flex-column justify-space-between">
                            <div class="mb-20 mb-lg-0">
                                <span class="d-block font-size-14 font-size-lg-20 font-weight-700 line-height-1 color-point mb-8 mb-lg-18">
                                    03
                                </span>
                                <p class="txt-22 font-weight-700">
                                    Web malware distribution <br class="pc">
                                    scanning
                                </p>
                            </div>
                            <div class="d-flex justify-end">
                                <img src="/images/main/s3-icon3.png" alt="" class="d-block">
                            </div>
                        </div>
                    </v-col>
                </v-row>
                
            </v-container>
        </section>

        <section class="main-section main-section4">
            <v-container>

                <h3 class="main-title">
                    UWSS Application Cases
                </h3>

                <div class="d-flex justify-space-between align-center mb-36 mb-lg-60">
                    <ul class="tab-button d-flex">
                        <li class="on mr-18 mr-lg-30 pb-6 pb-lg-12">
                            <button @click="getBoards('partners', '국내')"><span class="font-weight-700 txt-22 line-height-1">Domestic</span></button>
                        </li>
                        <li class="pb-6 pb-lg-12">
                            <button @click="getBoards('partners', '해외')"><span class="font-weight-700 txt-22 line-height-1">Oversea</span></button>
                        </li>
                    </ul>
                    <v-btn text class="arrow-btn right" to="/en/partners">View all <img src="/images/icon/right-arrow.png" alt=""></v-btn>
                </div>

                <ul class="tab-contents">
                    <li class="on">
                        <v-row>
                            <v-col v-for="partner in partners" :key="partner._id" cols="6" sm="4" lg="3">
                                <div class="border radius-sm apply-thum-wrap">
                                    <div class="apply-thum radius-sm" :style="`background-image: url(${partner.thumb})`"></div>
                                    <a v-if="partner.company.URL" :href="partner.company.URL" target="_blank" class="apply-link"></a>
                                </div>
                            </v-col>
                        </v-row>
                    </li>

                    <li>
                        <v-row>
                            <v-col v-for="partner in partners" :key="partner._id" cols="6" sm="4" lg="3">
                                <div class="border radius-sm apply-thum-wrap">
                                    <div class="apply-thum radius-sm" :style="`background-image: url(${partner.thumb})`"></div>
                                    <a v-if="partner.company.URL" :href="partner.company.URL" target="_blank" class="apply-link"></a>
                                </div>
                            </v-col>
                        </v-row>
                    </li>

                </ul>
                
            </v-container>
        </section>


        <popup-layer></popup-layer>

    </client-page>
</template>

<script>
import api from "@/api"
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import MainBanners from "@/components/client/en/main/main-banners.vue";
import MainSection from "@/components/client/en/main/main-section.vue";
// import MainVisual from "@/components/client/en/main/main-visual.vue";
import MainTextBanner from "@/components/client/en/main/main-text-banner.vue";
import MainAuctionsBanner from "@/components/client/en/main/main-auctions-banner.vue";
// import BoardList from "@/components/client/en/board/board-list.vue";
import PopupLayer from '@/components/client/en/popup/popup-layer.vue';
import LocaleSelect from "@/components/client/en/inc/locale-select.vue";
import { BOARD_YOUTUBE_CATEGORIES, BOARD_REPORT_CATEGORIES, BOARD_FORMS_CATEGORIES } from '@/assets/variables';

const categoriesYoutube = Object.values(BOARD_YOUTUBE_CATEGORIES)
const categoriesReport = Object.values(BOARD_REPORT_CATEGORIES)
const categoriesForms = Object.values(BOARD_FORMS_CATEGORIES)

export default {
    components: {
        ClientPage,
        MainBanners,
        MainSection,
        // MainVisual,
        MainTextBanner,
        MainAuctionsBanner,
        // BoardList,
        PopupLayer,
        LocaleSelect
    },
    props: {
        isMain: { type: Boolean, default: true },
    },
    data: () => ({
        categoriesYoutube,
        categoriesReport,
        categoriesForms,

        filter: {
            language: "en",
            code: "partners",
            category: "국내"
        },

        partners: []
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {
                // tab
                (function tabList(){
                    const tabList = document.querySelectorAll('.tab-button li'),
                    contentsList = document.querySelectorAll('.tab-contents li'),
                    tab = document.querySelectorAll('.tab-button li button');

                    if(tabList !== undefined){
                        for(let i = 0; i < tab.length; i++){
                            tab[i].addEventListener('click', function(){
                                tabMenuToggle(i);

                                if(contentsList[i] !== undefined) tabContentsToggle(i);
                            });
                        }
                    }

                    function tabMenuToggle(current){
                        for(let i = 0; i < tab.length; i++)
                            tabList[i].classList.remove('on');

                        tabList[current].classList.add('on');
                    }
                    function tabContentsToggle(current){
                        for(let i = 0; i < tab.length; i++)
                            contentsList[i].classList.remove('on');

                        contentsList[current].classList.add('on');
                    }
                })();
            });
            await this.getBoards('partners', '국내')
        },
        async getBoards(code, category){
            this.filter.code = code
            this.filter.category = category

            let { boards: partners } = await api.v1.boards.gets({
                params: { ...this.filter }
            })
            this.partners = partners
        }
    },
};
</script>

<style scoped>
.s2-left-item{
    background-image: url(/images/main/s2-img.png);
    background-position: center;
    background-size: cover;
}
.s2-right-logo{
    height: 44px;
}

.tab-contents { position: relative; }
.tab-contents > li { display: none; position: absolute; top: 0; left: 0; }
.tab-contents > li.on { display: block; height:auto; position:relative; animation: contents-on ease-in-out .5s forwards; }
@-webkit-keyframes contents-on { from { opacity: 0; } to { opacity: 1; } }
@keyframes contents-on { from { opacity: 0; } to { opacity: 1; } }

.tab-button li button{
    position: relative;
    transition: 0.2s ease-out;
}

.tab-button li.on button{
    color: var(--v-primary-base);
}

.tab-button li button::after{
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 3px;
    background-color: var(--v-primary-base);
    left: 0;
    bottom: -12px;
    transform: scaleY(0);
    transform-origin: center bottom;
    transition: 0.2s ease-out;
}

.tab-button li.on button::after{
    transform: scaleY(1);
}

.apply-thum-wrap{
    position: relative;
    width: 100%;
    height: 0;
    padding-top: calc((100 / 273) * 100%);
    overflow: visible;
}

.apply-thum{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    z-index: 1;
}

.apply-link{
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 2;
    transition: 0.2s ease-out;
}

@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .s2-right-logo{
        height: 48px;
    }
    .s3-item{
        height: 252px;
    }

    .tab-button li button:hover{
        color: var(--v-primary-base);
    }
    .apply-link:hover{
        box-shadow: 0 0 30px rgba(14, 20, 48, 0.05);
    }
}
@media (min-width:1200px){
}

</style>